
import React from 'react';
import { ArrowRight, Bug } from 'lucide-react';
import { SimulationConfig } from '@/types';

interface NavigationOverlayProps {
  config: SimulationConfig;
  setIsBugReportOpen: (open: boolean) => void;
}

export const NavigationOverlay: React.FC<NavigationOverlayProps> = ({ config, setIsBugReportOpen }) => {
  return (
    <div className="absolute top-6 left-6 z-40 flex flex-col gap-4">
      <button 
        onClick={() => window.location.href = '/'}
        className={`flex items-center gap-2 px-6 py-3 backdrop-blur-xl border rounded-full transition-all active:scale-95 group font-bold ${config.darkMode ? 'bg-white/5 border-white/10 text-white/50 hover:text-cyan-400 hover:border-cyan-400/30 hover:bg-cyan-400/5' : 'bg-black/5 border-black/10 text-black/60 hover:text-cyan-600 hover:border-cyan-600/30 hover:bg-cyan-600/5'}`}
      >
        <ArrowRight className="w-4 h-4 rotate-180 transition-transform group-hover:-translate-x-1" />
        Back to Portal
      </button>
      <button 
        onClick={() => setIsBugReportOpen(true)}
        className={`flex items-center gap-2 px-6 py-3 backdrop-blur-xl border rounded-full transition-all active:scale-95 group font-bold ${config.darkMode ? 'bg-white/5 border-white/10 text-white/50 hover:text-cyan-400 hover:border-cyan-400/30 hover:bg-cyan-400/5' : 'bg-black/5 border-black/10 text-black/60 hover:text-cyan-600 hover:border-cyan-600/30 hover:bg-cyan-600/5'}`}
      >
        <Bug className="w-4 h-4 transition-transform group-hover:scale-110" />
        Report Bug
      </button>
    </div>
  );
};
